import src from "IMAGE";
export default { src, width: 1350, height: 360, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAR0lEQVR42hXLQQqAQAhA0blA0D6H0lRchBcIDITA+59oZt7mr35jZkLEEwCOzPyq6ldV7r3DNjUiusxMV939iYhXRO417tMARyoJlLDMgugAAAAASUVORK5CYII="};
